// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"styles_backdrop__33Kc7","open":"styles_open__3cBmR","child":"styles_child__1cD8j","close":"styles_close__CgQUd"};